import { AxiosPromise } from 'axios';

import { IAssetDetails } from './interfaces';
import { vaultApi } from '../api';

const basePath = '/assets/download';
const sourcePath = '/assets/source';

/* eslint-disable implicit-arrow-linebreak */

/*
 * VV-539: `purpose` replaces the old `excludeLog` flag. The access is now always recorded
 * — the caller cannot opt out of the audit log — and `purpose` only says which action type
 * the row carries:
 *   - 'download' (default): a real download, recorded as Download / DownloadPreview
 *   - 'share': a link copied or emailed, recorded as Shared. Nobody fetches the bytes, so
 *     counting it as a download overstated downloads.
 *   - 'probe': a rendition-availability check, recorded as RenditionCheck. The URL is real
 *     and usable, so it has to be logged, but it is not a download.
 */
export type AccessPurpose = 'download' | 'share' | 'probe';

export const getDownloadLink = <T>(params: IAssetDetails, expiresInHours: number = 1, purpose: AccessPurpose = 'download', isPreview: boolean = false): AxiosPromise<any> =>
  vaultApi.getInstance().get(`${basePath}/${params.id}?expiresInHours=${expiresInHours}&purpose=${purpose}&isPreview=${isPreview}`);

/*
 * VV-539: `/assets/source` returns the original uploaded master file and now requires the
 * `downloadSource` permission (Super Admin), so this rejects with a 4xx for everyone else
 * — callers must handle that rather than assuming a URL. It previously took an
 * `excludeLog` argument that the endpoint ignored, since it never logged anything at all.
 */
export const getSourceLink = <T>(params: IAssetDetails, expiresInHours: number = 1, purpose: AccessPurpose = 'download'): AxiosPromise<any> =>
  vaultApi.getInstance().get(`${sourcePath}/${params.id}?expiresInHours=${expiresInHours}&purpose=${purpose}`);
